import RegisterAccountInfoForm from './register-account-info-form-container';

export default RegisterAccountInfoForm;
